import type { SVGComponent } from '../../typings'

type PinProps = {
  outline?: boolean
}

export const Pin: SVGComponent<PinProps> = ({ outline, ...props }) => {
  if (outline) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 20.9571C10.9747 19.1164 9.56565 17.7745 8.31926 16.5876C7.94282 16.2291 7.58122 15.8847 7.24951 15.545C5.68908 13.947 4.5 12.2488 4.5 9.15385C4.5 5.09015 7.92944 1.75 12.0973 1.75C16.2351 1.75 19.5 5.06051 19.5 9.15385C19.5 12.2488 18.3109 13.947 16.7505 15.545C16.4188 15.8847 16.0572 16.2291 15.6807 16.5876C14.4344 17.7745 13.0253 19.1164 12 20.9571Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="12" cy="9.5" r="3" fill="currentColor" />
      </svg>
    )
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3642 17.3643C14.6643 19.0211 12.8883 20.752 12 23.75C11.1117 20.752 9.33571 19.0211 7.63578 17.3643C5.50832 15.2908 3.5 13.3334 3.5 9.15385C3.5 4.51253 7.40283 0.75 12.0973 0.75C16.7917 0.75 20.5 4.51253 20.5 9.15385C20.5 13.3334 18.4917 15.2908 16.3642 17.3643ZM12 12.25C13.6569 12.25 15 10.9069 15 9.25C15 7.59315 13.6569 6.25 12 6.25C10.3431 6.25 9 7.59315 9 9.25C9 10.9069 10.3431 12.25 12 12.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
